import mountOptionPicker from './optionPicker';
import {
    IOptionPickerTextItem,
} from '@vfde-brix-ws10/option-picker';

 /**
  * Mount Text Option Picker
  * @param container
  * @param id
  * @param items
  * @param onChangeAction
  */
export const mountTextOptionPicker = (container: HTMLElement, id: string, items: IOptionPickerTextItem[], onChangeAction?: (value: string) => void) => {

    return mountOptionPicker(container, id, 'text', items, onChangeAction, 'stacked');
};
